import { useState } from 'react';
import { useQueryClient } from 'react-query';
import { useCreateAdaptedFictionEditionComment } from '../../../domains/scene/ui/hooks/useCreateAdaptedFictionEditionComment';
import { getCastRelationshipId } from '../utils/getCastRelationshipId';

interface UseCreateCommentProps {
  adaptedFictionEditionId: string;
  /** SceneMainPage 등 AdaptedFictionPreview 컨텍스트가 필요한 경우 전달 */
  adaptedFictionPreviewId?: string;
  /** ScenePreviewDetailPage 등 Scene 컨텍스트가 필요한 경우 전달 */
  sceneId?: string;
}

export const useCreateComment = ({
  adaptedFictionEditionId,
  adaptedFictionPreviewId,
  sceneId
}: UseCreateCommentProps) => {
  const [comment, setComment] = useState('');
  const [isAnonymous, setIsAnonymous] = useState(false);

  const queryClient = useQueryClient();

  const castRelationshipId = getCastRelationshipId();

  const { mutateAsync: createAdaptedFictionEditionComment } = useCreateAdaptedFictionEditionComment(
    {
      adaptedFictionEditionId
    }
  );

  const handleCreateAdaptedFictionEditionComment = async (parentId?: string) => {
    const requestBody = {
      comment: {
        content: comment,
        parent_id: parentId ? parentId : null,
        anonymous: isAnonymous,
        engagement_contexts: [
          ...(sceneId
            ? [{ context_type: 'Scene' as const, context_id: sceneId }]
            : adaptedFictionPreviewId
              ? [
                  {
                    context_type: 'AdaptedFictionPreview' as const,
                    context_id: adaptedFictionPreviewId
                  }
                ]
              : []),
          {
            context_type: 'CastRelationship' as const,
            context_id: castRelationshipId
          }
        ]
      }
    };
    const response = await createAdaptedFictionEditionComment(requestBody);
    if (response.commentId) {
      setComment('');
      if (sceneId) {
        queryClient.invalidateQueries(['sceneDetail', sceneId]);
      }
    }
  };

  return {
    comment,
    setComment,
    isAnonymous,
    setIsAnonymous,
    handleCreateAdaptedFictionEditionComment
  };
};
